import { configureStore } from '@reduxjs/toolkit';
import appReducer from './slices/appSlice';
import authReducer from './slices/auth/authSlice';
import profileReducer from './slices/user/profileSlice';
import dashboardReducer from './slices/dashboard/dashboardSlice';
import iframeReducer from './slices/iframe/iframeSlice';
import ctaReducer from './slices/cta/ctaSlice';
import engReducer from './slices/eng/engSlice';
import endScreenReducer from './slices/endScreen/endScreenSlice';
import domainReducer from './slices/domains/domainSlice';
import pagesReducer from './slices/pages/pagesSlice';
import teamReducer from './slices/team/teamSlice';
import analyticsReducer from './slices/analytics/analyticsSlice';
import agentReducer from './slices/agents/agentSlice';
import schedulingFormReducer from './slices/schedulingFormSlice';
import commandPaletteReducer from './slices/commandPaletteSlice';
import tourReducer from './slices/tourSlice';
import supportDrawerReducer from './slices/supportDrawerSlice';
import helpChatReducer from './slices/helpChatSlice';
import agentOverviewReducer from './slices/agents/agentOverviewSlice';
import collectionsV1Reducer from './slices/collections-v1/collectionsV1Slice';
import collectionsV2Reducer from './slices/collections-v2/collectionsV2Slice';
import { bridgedApi } from '../services/api';
import aiLabsReducer from './slices/AILabs/aiLabsSlice';
import fineTuningReducer from './slices/FineTuning/fineTuningSlice';
import brandingReducer from './slices/branding/brandingSlice';
import fontsReducer from './slices/fontsSlice';
import abTestReducer from './slices/abTest/abTestSlice';
import webhooksReducer from './slices/integrations/webhooksSlice';
import communicationsReducer from './slices/integrations/communicationsSlice';
import platformReducer from './slices/platform/platformSlice';
import eventsReducer from './slices/events/eventsSlice';

// Create and configure the Redux store
const store = configureStore({
  reducer: {
    // Include reducers for different parts of your application
    app: appReducer, // App related state
    auth: authReducer, // Authentication related state
    user: profileReducer, // Authentication related state
    dashboard: dashboardReducer, // dashboard related state
    iframe: iframeReducer, // iframe related state
    cta: ctaReducer, // Cta related state
    eng: engReducer, // Engagement related state
    endScreen: endScreenReducer, // End Screen related state
    collectionsV1: collectionsV1Reducer, // Collections V1 (actionBucket) state
    collectionsV2: collectionsV2Reducer, // Collections V2 (new module) state
    domain: domainReducer, // Domain related state
    pages: pagesReducer, // Pages related state
    team: teamReducer, // Team related state
    analytics: analyticsReducer, // Team related state
    agent: agentReducer, // Agent related state
    fonts: fontsReducer, // Fonts related state
    schedulingForm: schedulingFormReducer, // Scheduling form related state
    commandPalette: commandPaletteReducer, // Command palette related state
    tour: tourReducer, // Guided tour that is running
    supportDrawer: supportDrawerReducer, // Global support/feedback drawer state
    helpChat: helpChatReducer, // Help → Ask AI side panel
    agentOverview: agentOverviewReducer, // Agent Overview related state
    aiLabs: aiLabsReducer, // AI Labs related state
    fineTuning: fineTuningReducer, // Fine Tuning related state
    [bridgedApi.reducerPath]: bridgedApi.reducer, // API related state
    branding: brandingReducer, // Branding related state
    abTest: abTestReducer, // A/B Test create form state
    webhooks: webhooksReducer, // Webhooks related state
    communications: communicationsReducer, // Communications integrations state
    platform: platformReducer, // Hostname-based platform (media | events)
    events: eventsReducer, // Selected event wrapper context
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(bridgedApi.middleware), // Apply middleware for API
});

export default store;
